import PropTypes from 'prop-types';
import React from 'react';

import {
  CalendarToolbar, MonthLabel, NavButton, NavButtonContainer, NavIcon,
} from './styles';

export const EventCalendarToolbar = ({
  label,
  hasPreviousMonth = false,
  hasNextMonth = false,
  onPreviousMonth,
  onNextMonth,
  colorProfile = null,
}) => (
  <CalendarToolbar>
    <MonthLabel>{label}</MonthLabel>
    <NavButtonContainer>
      <NavButton
        type="button"
        aria-label="Previous month with events"
        onClick={onPreviousMonth}
        disabled={!hasPreviousMonth}
        $colorProfile={colorProfile}
      >
        <NavIcon 
          className="prev"
          name="ui-arrow-circle-left" 
          width="35"
          $colorProfile={colorProfile}
        />
      </NavButton>
      <NavButton
        type="button"
        aria-label="Next month with events"
        onClick={onNextMonth}
        disabled={!hasNextMonth}
        $colorProfile={colorProfile}
      >
        <NavIcon 
          className="next"
          name="ui-arrow-circle-right" 
          width="35"
          $colorProfile={colorProfile}
        />
      </NavButton>
    </NavButtonContainer>
  </CalendarToolbar>
);

EventCalendarToolbar.propTypes = {
  label: PropTypes.string.isRequired,
  hasPreviousMonth: PropTypes.bool,
  hasNextMonth: PropTypes.bool,
  onPreviousMonth: PropTypes.func.isRequired,
  onNextMonth: PropTypes.func.isRequired,
  colorProfile: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
